var _style, _path, _g, _path2, _path3, _text, _g2, _g3, _text2, _text3, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoStratusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "121.1px",
    height: "30px",
    viewBox: "0 0 121.1 30",
    style: {
      enableBackground: "new 0 0 121.1 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000066481767484409778870000000720728069887853467_);}\r\n\t.st2{display:none;}\r\n\t.st3{display:inline;opacity:0.31;fill:#F0E3FC;enable-background:new    ;}\r\n\t.st4{display:none;opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st5{fill:url(#SVGID_00000001626914109315693370000007558917161998765440_);}\r\n\t.st6{fill:url(#SVGID_00000084506184041092066940000016596020569539596429_);}\r\n\t.st7{fill:url(#SVGID_00000062888636332992716230000003936983704453225895_);}\r\n\t.st8{fill:url(#SVGID_00000101791481628376320730000009848964231360357551_);}\r\n\t.st9{fill:url(#SVGID_00000177456261991451976880000009540006743952752012_);}\r\n\t.st10{fill:url(#SVGID_00000101100824307112890250000016222009417093744048_);}\r\n\t.st11{display:none;enable-background:new    ;}\r\n\t.st12{font-family:'HelveticaNeueLTStd-Md';}\r\n\t.st13{font-size:126.3863px;}\r\n\t.st14{enable-background:new    ;}\r\n\t.st15{fill:#FFFFFF;}\r\n\t.st16{font-size:110.2764px;}\r\n\t.st17{font-family:'TrajanPro-Regular';}\r\n\t.st18{font-size:124.5487px;}\r\n\t\r\n\t\t.st19{display:none;clip-path:url(#SVGID_00000110434333246443043160000014619190771231597980_);fill:url(#SVGID_00000126321085398390508250000017721305206348466829_);}\r\n\t.st20{display:none;clip-path:url(#SVGID_00000178169132482848306420000017103181664895471261_);fill:#F0E3FC;}\r\n\t\r\n\t\t.st21{clip-path:url(#SVGID_00000119821982004328829920000003505196430676315048_);fill:url(#SVGID_00000116957457038977265400000001560902628844097467_);}\r\n\t.st22{clip-path:url(#SVGID_00000000936000364446100250000005032278562364891304_);fill:#F0E3FC;}\r\n\t\r\n\t\t.st23{clip-path:url(#SVGID_00000090273132748394904520000000395255701093162925_);fill:url(#SVGID_00000143588895109067003070000005560407590675842958_);}\r\n\t.st24{clip-path:url(#SVGID_00000147211010028145807240000003114174529559935653_);fill:#F0E3FC;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5748,
    y1: 15.223,
    x2: 20.1241,
    y2: 41.038,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.4,26.5c0,0.3-0.3,0.5-0.7,0.5H10c-0.4,0-0.7-0.2-0.7-0.5V2.1c0-0.3,0.3-0.5,0.7-0.5h20.7 c0.4,0,0.7,0.2,0.7,0.5L31.4,26.5L31.4,26.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000034769772326721244220000005296700447606375344_",
    cx: 18.5663,
    cy: 26.044,
    r: 16.7271,
    fx: 10.1073,
    fy: 14.7734,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034769772326721244220000005296700447606375344_)"
    },
    d: "M30.8,25.9c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.8c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.8,30.8,25.9,30.8,25.9z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-171.5,108.4c0-0.1,0-0.3,0-0.4c0-10.6-12-19.2-26.7-19.2c-7.1,0-13.5,2-18.3,5.2 c-4.7-7.9-15.7-13.5-28.5-13.5c-8.4,0-15.9,2.4-21.5,6.2c-5.9-9.9-19.6-16.9-35.6-16.9c-21.3,0-38.7,12.4-38.7,27.8 c0,3.8,1.1,7.4,3,10.8L-171.5,108.4L-171.5,108.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-260.9-5.4c50-14.7,92.5,4.7,92.5,4.7v-84c0-2.2-2.3-4-5.2-4H-337c-2.9,0-5.2,1.8-5.2,4v50.3 C-342.2-34.3-310.9,9.2-260.9-5.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039111423752926916350000012854230202877088693_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5,
    y1: 23.35,
    x2: 1.7,
    y2: 23.35,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039111423752926916350000012854230202877088693_)"
    },
    d: "M1.7,13.9c0,0,7.3-8.7,18.8-8.7 s18,8.7,18,8.7s-8.7-6.7-18.1-6.7C11,7.3,1.7,13.9,1.7,13.9z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.3,35.1c-26.6-2.3-45.4-1.2-45.4-1.2s18.5-6,46.4-7.9C127.8,23.9,126.7,38.1,93.3,35.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025434950851126536170000000371992857837953450_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.086,
    y1: 29.05,
    x2: 3.1028,
    y2: 29.05,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025434950851126536170000000371992857837953450_)"
    },
    d: "M3.1,19.3c0,0,6.7-8.1,17.3-8.1 S37,19.3,37,19.3s-8-6.4-16.7-6.4C11.7,12.9,3.1,19.3,3.1,19.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066495848742856778530000014041767421181725837_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.5636,
    y1: 33.5,
    x2: 4.6371,
    y2: 33.5,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066495848742856778530000014041767421181725837_)"
    },
    d: "M4.6,23.1c0,0,6.1-6.8,15.8-6.8 s15.2,6.8,15.2,6.8s-7.6-5.4-15.5-5.4S4.6,23.1,4.6,23.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008859774737445370970000000344045343087028903_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4,
    y1: 22.8,
    x2: 37.7497,
    y2: 22.8,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008859774737445370970000000344045343087028903_)"
    },
    d: "M2.4,13.2c0,0,7-8.4,18-8.4 s17.3,8.4,17.3,8.4s-8.4-6.4-17.4-6.4S2.4,13.2,2.4,13.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003065576149345843630000016353810798145408698_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.8,
    y1: 28.2,
    x2: 36.4526,
    y2: 28.2,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003065576149345843630000016353810798145408698_)"
    },
    d: "M3.8,18.3c0,0,6.4-7.8,16.6-7.8 s16,7.8,16,7.8s-7.7-6.1-16.1-6.1C12,12.2,3.8,18.3,3.8,18.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049929672171843392140000016059708986956857021_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.2365,
    y1: 32.55,
    x2: 34.9523,
    y2: 32.55,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049929672171843392140000016059708986956857021_)"
    },
    d: "M5.2,22c0,0,5.9-6.5,15.2-6.5S35,22,35,22 s-7.3-5.2-14.8-5.2C12.5,16.9,5.2,22,5.2,22z"
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -106.4805 -0.9991)",
    className: "st11 st12 st13"
  }, "Dispatcher")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M39.4,2h4.5c3.3,0,4.8,2.4,4.8,5.4s-1.4,5.4-4.8,5.4h-4.5V2z M41.3,11.2h1.9c3,0,3.6-1.7,3.6-3.9 s-0.6-3.9-3.6-3.9h-1.9V11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M50.1,2h1.7v1.6h-1.7V2z M50.1,5h1.7v7.8h-1.7V5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M55,10.3c0.1,1,0.8,1.4,1.8,1.4c0.7,0,1.8-0.1,1.7-1c0-0.9-1.3-1-2.6-1.3C54.7,9,53.5,8.6,53.5,7 c0-1.7,1.8-2.2,3.3-2.2c1.6,0,3.1,0.7,3.3,2.4h-1.8c-0.2-0.8-0.8-1-1.6-1c-0.5,0-1.4,0.1-1.4,0.8c0,0.8,1.3,1,2.5,1.3 c1.3,0.3,2.5,0.7,2.5,2.3c0,1.9-1.9,2.5-3.5,2.5c-2,0-3.4-0.9-3.5-2.7H55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M61.6,5h1.6V6h0c0.5-0.9,1.4-1.3,2.4-1.3c2.5,0,3.7,1.9,3.7,4.2c0,2.1-1.1,4.1-3.4,4.1c-1,0-2.1-0.4-2.6-1.2 h0v3.9h-1.7V5z M65.5,6.1c-1.5,0-2.2,1.1-2.2,2.8c0,1.6,0.8,2.8,2.2,2.8c1.6,0,2.2-1.4,2.2-2.8C67.6,7.5,66.9,6.1,65.5,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M77.4,11.1c0,0.4,0.1,0.6,0.4,0.6c0.1,0,0.2,0,0.4,0v1.2C78,12.9,77.4,13,77.1,13c-0.7,0-1.2-0.2-1.3-1 c-0.7,0.7-1.8,1-2.7,1c-1.4,0-2.7-0.8-2.7-2.3c0-2,1.6-2.3,3-2.4c1.2-0.2,2.3-0.1,2.3-1.1c0-0.9-0.9-1.1-1.6-1.1 c-1,0-1.7,0.4-1.7,1.2h-1.7c0.1-2,1.8-2.6,3.6-2.6c1.5,0,3.1,0.6,3.1,2.3V11.1z M75.7,8.9c-0.5,0.3-1.4,0.3-2.1,0.5 c-0.7,0.1-1.4,0.4-1.4,1.3c0,0.8,1,1,1.6,1c0.8,0,1.9-0.4,1.9-1.5V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M78.5,5h1.3V2.6h1.7V5h1.6v1.3h-1.6v4.2c0,0.7,0.1,1.1,0.8,1.1c0.2,0,0.5,0,0.7-0.1v1.3 c-0.4,0-0.7,0.1-1.1,0.1c-1.8,0-2.1-0.7-2.2-2V6.2h-1.3V5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M89.6,7.6c-0.1-1-0.8-1.5-1.8-1.5c-0.9,0-2.2,0.5-2.2,2.8c0,1.3,0.6,2.7,2.1,2.7c1,0,1.7-0.7,1.9-1.8h1.7 c-0.3,2-1.6,3.2-3.6,3.2c-2.5,0-3.8-1.7-3.8-4c0-2.4,1.3-4.2,3.9-4.2c1.8,0,3.4,0.9,3.5,2.8H89.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M92.7,2h1.7v4h0c0.4-0.7,1.3-1.2,2.3-1.2c1.7,0,2.8,0.9,2.8,2.7v5.4h-1.7V7.9c0-1.2-0.5-1.8-1.5-1.8 c-1.2,0-1.9,0.9-1.9,2.1v4.6h-1.7V2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M102.8,9.3c0,1.2,0.7,2.3,2.1,2.3c1,0,1.6-0.4,1.9-1.3h1.6c-0.4,1.7-1.8,2.7-3.5,2.7c-2.5,0-3.8-1.7-3.8-4.1 c0-2.2,1.5-4.1,3.8-4.1c2.5,0,4,2.2,3.7,4.6H102.8z M106.8,8.2c-0.1-1.1-0.8-2.1-2-2.1c-1.2,0-2,0.9-2.1,2.1H106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.8,5h1.6v1.5h0c0.2-0.8,1.2-1.7,2.3-1.7c0.4,0,0.5,0,0.7,0v1.7c-0.2,0-0.5-0.1-0.7-0.1 c-1.2,0-2.1,1-2.1,2.7v3.7h-1.7V5z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.97 0 0 1 210.0117 107.1504)",
    className: "st11",
    style: {
      fontFamily: "'HelveticaNeueLTStd-LtIt'",
      fontSize: "94.6381px"
    }
  }, "Phoenix"), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M79.7,18.8c0-1.8-0.9-2.4-2.6-2.4c-1.2,0-2.5,0.6-2.5,2.1c0,1.1,0.8,1.4,1.7,1.7l1.1,0.3 c1.4,0.4,2.7,0.9,2.7,2.6c0,1-0.6,3.2-3.8,3.2c-2.2,0-3.9-1.1-3.8-3.6h0.9c-0.1,2,1.1,2.8,2.9,2.8c1.3,0,2.8-0.7,2.8-2.2 c0-1.5-1.4-1.7-2.5-2l-1-0.3c-1.2-0.3-2-1.1-2-2.4c0-2.1,1.8-2.9,3.5-2.9c2,0,3.7,0.8,3.5,3.2H79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M81.5,18.7h1.3l0.5-2.2h0.9l-0.5,2.2h1.4L85,19.4h-1.5l-1,4.8c-0.1,0.3-0.1,0.5-0.1,0.7 c0,0.3,0.1,0.5,0.5,0.5c0.3,0,0.7,0,1-0.1l-0.2,0.8c-0.3,0-0.6,0.1-0.9,0.1c-0.7,0-1.3-0.2-1.3-1.1c0-0.2,0-0.4,0.1-0.8l1-4.9h-1.3 L81.5,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M86.5,18.7h0.8l-0.4,1.7h0c0.6-1.1,1.3-1.8,2.6-1.8c0.2,0,0.3,0,0.5,0l-0.2,0.9c-0.2,0-0.3,0-0.5,0 c-1.6,0-2.4,1.3-2.7,2.7l-0.8,3.9h-0.9L86.5,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M90.3,20.9c0.2-1.7,1.5-2.4,3-2.4c1,0,2.5,0.3,2.5,1.7c0,0.7-0.3,1.8-0.4,2.5c-0.3,1.7-0.5,2.1-0.5,2.5 c0,0.3,0.3,0.3,0.5,0.3c0.1,0,0.2,0,0.3,0l-0.1,0.7c-0.2,0-0.5,0.1-0.7,0.1c-0.5,0-0.8-0.3-0.8-0.8c0-0.1,0-0.3,0-0.4l0,0 c-0.5,0.9-1.5,1.4-2.5,1.4c-1.3,0-2.3-0.6-2.3-2.1c0-1.6,1.2-2.1,2.5-2.3c0.9-0.1,1.7-0.1,2.3-0.2c0.6-0.1,0.9-0.5,0.9-1.5 c0-0.9-0.9-1.1-1.5-1.1c-1.1,0-2.1,0.4-2.3,1.7H90.3z M94.7,22.1L94.7,22.1c-0.3,0.3-1.2,0.4-1.6,0.4c-1.1,0.1-2.8,0.1-2.8,1.7 c0,0.9,0.8,1.3,1.6,1.3c1.4,0,2.3-0.9,2.6-2.2L94.7,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M97.3,18.7h1.3l0.5-2.2h0.9l-0.5,2.2h1.4l-0.1,0.8h-1.5l-1,4.8c-0.1,0.3-0.1,0.5-0.1,0.7 c0,0.3,0.1,0.5,0.5,0.5c0.3,0,0.7,0,1-0.1l-0.2,0.8c-0.3,0-0.6,0.1-0.9,0.1c-0.7,0-1.3-0.2-1.3-1.1c0-0.2,0-0.4,0.1-0.8l1-4.9h-1.3 L97.3,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M106.4,26.1h-0.8l0.3-1.4h0c-0.5,0.9-1.5,1.6-2.6,1.6c-1.3,0-2.2-0.6-2.2-2c0-0.2,0-0.5,0.1-0.9l1-4.8h0.9 l-1,4.8c-0.1,0.2-0.1,0.5-0.1,0.7c0,1,0.7,1.3,1.5,1.3c1.3,0,2.4-1.2,2.8-3.1l0.8-3.8h0.9L106.4,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.2,23.7c0,1.4,1,1.9,2,1.9c0.8,0,1.8-0.4,1.8-1.4c0-1-1-1.3-1.9-1.6c-1-0.4-1.9-0.8-1.9-2.1 c0-1.4,1.5-2,2.7-2c1.5,0,2.6,0.7,2.6,2.4h-0.9c0.1-1.1-0.7-1.6-1.7-1.6c-0.8,0-1.8,0.2-1.8,1.3c0,0.7,0.7,1,1.5,1.4 c1,0.4,2.3,0.8,2.3,2.2c0,1.7-1.5,2.3-2.9,2.3c-1.4,0-2.8-0.8-2.7-2.6H109.2z"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.2357 0 0 1 -11.4263 102.7305)",
    className: "st11 st12 st16"
  }, "Phoenix")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -44.0137 114.5771)",
    className: "st11 st17 st18"
  }, "Phoenix ")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000181767295844036263300000004728912061769024396_",
    d: "M30.8,25.7c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.6c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.6,30.8,25.7,30.8,25.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003794585223923463250000005497073414227616920_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181767295844036263300000004728912061769024396_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013182794102200785250000007344522037858335632_",
    cx: 20.95,
    cy: 37.7471,
    r: 9.0795,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      clipPath: "url(#SVGID_00000003794585223923463250000005497073414227616920_)",
      fill: "url(#SVGID_00000013182794102200785250000007344522037858335632_)"
    },
    d: " M33,28.2c0-0.1,0-0.1,0-0.2c0-1.9-2.1-3.4-4.7-3.5c0.1-0.2,0.1-0.4,0.1-0.6c0-1.2-1.4-2.2-3-2.2c-0.4,0-0.8,0.1-1.2,0.2 c-0.4-1.3-2-2.2-3.9-2.2c-2.2,0-4,1.3-4,2.9l0,0c-0.1,0-0.2,0-0.2,0c-1.6,0-3,0.9-3.2,2c-0.1,0-0.3,0-0.4,0 c-2,0-3.6,1.2-3.6,2.6c0,0.4,0.1,0.8,0.4,1.1L33,28.2L33,28.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000140696505117322218750000007965353510208725386_",
    d: "M30.8,25.7c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.6c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.6,30.8,25.7,30.8,25.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020395927111005080950000007871729806892506265_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000140696505117322218750000007965353510208725386_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      clipPath: "url(#SVGID_00000020395927111005080950000007871729806892506265_)",
      fill: "#F0E3FC"
    },
    d: " M32.8,28.4c0-0.1,0-0.1,0-0.2c0-1.9-2.1-3.4-4.7-3.5c0.1-0.2,0.1-0.4,0.1-0.6c0-1.2-1.4-2.2-3-2.2c-0.4,0-0.8,0.1-1.2,0.2 c-0.4-1.3-2-2.2-3.9-2.2c-2.2,0-4,1.3-4,2.9l0,0c-0.1,0-0.2,0-0.2,0c-1.6,0-3,0.9-3.2,2c-0.1,0-0.3,0-0.4,0 c-2,0-3.6,1.2-3.6,2.6c0,0.4,0.1,0.8,0.4,1.1L32.8,28.4L32.8,28.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000153672894306112311550000016131868453261287307_",
    d: "M30.8,25.7c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.6c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.6,30.8,25.7,30.8,25.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075153615457809051360000001096584562129442222_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153672894306112311550000016131868453261287307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000129928767005093451000000000048252006315078330_",
    cx: 25.2368,
    cy: 39.0357,
    r: 8.7112,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000075153615457809051360000001096584562129442222_)",
      fill: "url(#SVGID_00000129928767005093451000000000048252006315078330_)"
    },
    d: " M36.8,27.2c0-1.4-1.2-2.6-2.6-2.6c-0.3,0-0.5,0-0.8,0.1c-0.4-1.4-1.7-2.4-3.2-2.4c-0.9,0-1.7,0.3-2.3,0.9 c-0.6-1.4-1.9-2.4-3.5-2.4s-3,1-3.5,2.4c-1.5,0-2.6,1.2-2.8,2.6c-0.2,0-0.3-0.1-0.5-0.1c-1,0-1.8,0.6-2.1,1.5 c-0.1,0-0.1,0-0.2,0c-0.8,0-1.5,0.7-1.5,1.5c0,0.3,0.1,0.5,0.2,0.7h21.3l0,0C36.1,29.2,36.8,28.3,36.8,27.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026848231396471814390000005003201834134087068_",
    d: "M30.8,25.7c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.6c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.6,30.8,25.7,30.8,25.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061450766327173247170000015531600460219784859_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026848231396471814390000005003201834134087068_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000061450766327173247170000015531600460219784859_)",
      fill: "#F0E3FC"
    },
    d: "M36.6,27.4 c0-1.4-1.2-2.6-2.6-2.6c-0.3,0-0.5,0-0.8,0.1c-0.4-1.4-1.7-2.4-3.2-2.4c-0.9,0-1.7,0.3-2.3,0.9C27.2,22,25.8,21,24.2,21 c-1.6,0-3,1-3.5,2.4c-1.5,0-2.6,1.2-2.8,2.6c-0.2,0-0.3-0.1-0.5-0.1c-1,0-1.8,0.6-2.1,1.5c-0.1,0-0.1,0-0.2,0 c-0.8,0-1.5,0.7-1.5,1.5c0,0.3,0.1,0.5,0.2,0.7h21.3l0,0C36,29.3,36.6,28.4,36.6,27.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000160910955095410633080000016330246339555260835_",
    d: "M30.8,25.7c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.6c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.6,30.8,25.7,30.8,25.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064334698133635778150000003085036385754041485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160910955095410633080000016330246339555260835_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000091721373736366400660000015773939783351783573_",
    cx: 17.1576,
    cy: 37.8,
    r: 8.7115,
    gradientTransform: "matrix(1 0 0 1 0 -13.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#652D90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    style: {
      stopColor: "#5D2C8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5934,
    style: {
      stopColor: "#472879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#262261"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000064334698133635778150000003085036385754041485_)",
      fill: "url(#SVGID_00000091721373736366400660000015773939783351783573_)"
    },
    d: " M7.1,28.3L7.1,28.3h21.3c0.1-0.2,0.2-0.5,0.2-0.7c0-0.8-0.7-1.5-1.5-1.5c-0.1,0-0.2,0-0.2,0c-0.3-0.9-1.1-1.5-2.1-1.5 c-0.2,0-0.4,0-0.5,0.1c-0.2-1.4-1.3-2.6-2.8-2.6c-0.5-1.4-1.9-2.4-3.5-2.4s-2.9,1-3.5,2.4c-0.6-0.6-1.4-0.9-2.3-0.9 c-1.5,0-2.8,1-3.2,2.4c-0.2-0.1-0.5-0.1-0.8-0.1c-1.4,0-2.6,1.2-2.6,2.6C5.6,27,6.3,27.9,7.1,28.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000023984155979509536490000011088670121924072839_",
    d: "M30.8,25.7c0,0.3-0.3,0.5-0.6,0.5H10.6 c-0.3,0-0.6-0.2-0.6-0.5V2.6c0-0.3,0.3-0.5,0.6-0.5h19.6c0.3,0,0.6,0.2,0.6,0.5C30.8,2.6,30.8,25.7,30.8,25.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001644693180669352090000002238027291336061361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023984155979509536490000011088670121924072839_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000001644693180669352090000002238027291336061361_)",
      fill: "#F0E3FC"
    },
    d: "M6.9,28.6L6.9,28.6 h21.3c0.1-0.2,0.2-0.5,0.2-0.7c0-0.8-0.7-1.5-1.5-1.5c-0.1,0-0.2,0-0.2,0c-0.3-0.9-1.1-1.5-2.1-1.5c-0.2,0-0.4,0-0.5,0.1 c-0.2-1.4-1.3-2.6-2.8-2.6C20.8,21,19.4,20,17.8,20s-2.9,1-3.5,2.4c-0.6-0.6-1.4-0.9-2.3-0.9c-1.5,0-2.8,1-3.2,2.4 c-0.2-0.1-0.5-0.1-0.8-0.1c-1.4,0-2.6,1.2-2.6,2.6C5.4,27.3,6,28.2,6.9,28.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStratusWhite);
export default __webpack_public_path__ + "static/media/logo_stratus_white.2d2bcea1e6974f1d06ae4c279a17dce4.svg";
export { ForwardRef as ReactComponent };